/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState} from "react";
import AppContainer from "../Components/Structure/AppContainer.js";
import {Toaster} from "react-hot-toast";
import RegisterCard from "../Components/StudentCard/RegisterCard.js";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import AssignedCards from "../Components/StudentCard/AssignedCards.js";
import UnassignedCards from "../Components/StudentCard/UnassignedCards.js";
import InactiveCards from "../Components/StudentCard/InactiveCards.js";
import CardContext from "../Context/CardContext.js";
import AllCards from "../Components/StudentCard/AllCards.js";
import { Link } from "react-router-dom";
import LostCards from "../Components/StudentCard/LostCards.js";
import useStateCallback from "../util/customHooks/useStateCallback.js";
import TableHeader from "../Components/Common/TableHeader.js";
import ajaxCard from "../util/remote/ajaxCard.js";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

function CardsPage() {
  const [modal, setModal] = useStateCallback(false);
  const [assignedPerSchool, setAssignedPerSchool] = useState([]);
    // const [loading, setLoading] = useState(false);
  const {page, unassignedPage, allCardsCount, cardsCount, wristbandsCount, assignedCardsCount, assignedWristbandsCount, getCards, getUnassignedCards, countAllCards, 
        countAssignedCards, countAssignedWristbands, countOnlyCards, countOnlyWristbands} = useContext(CardContext);
  const [loadingPage, setLoadingPage] = useState(true);

  // useEffect(() => {
  //   countAssignedCards();
  //   countAssignedWristbands();
  //   countAllCards();
  //   countOnlyCards();
  //   countOnlyWristbands();
  //   getAssignedPerSchool();
  // }, []);

  useEffect(() => {
      const fetchAll = async () => {
        setLoadingPage(true);
        await Promise.all([
          countAssignedCards(),
          countAssignedWristbands(),
          countAllCards(),
          countOnlyCards(),
          countOnlyWristbands(),
          getAssignedPerSchool(),
        ]);
        setLoadingPage(false);
      };
    fetchAll();
    }, []);

  const getAssignedPerSchool = async () => {
      const server_response = await ajaxCard.totalCardsAndWristbandsPerSchool();
      if (server_response.status === "OK") {
        setAssignedPerSchool(server_response.details);
      } else {
        setAssignedPerSchool([]);
      }
  };

  const registerCard=(e,item)=>{
    setModal(false, ()=>setModal(<RegisterCard getAllCards={getCards} page={page} countAllCards={countAllCards} 
      getUnassignedCards={getUnassignedCards} unassignedPage={unassignedPage}/>))
  }

  const handleReset = (e) => {
    e.preventDefault();
    getAssignedPerSchool();
    
  };
  
  return (
   
    <AppContainer title="Buzz Cards / Wristbands">
       {modal}
      <Toaster position="top-center" reverseOrder={false} />
      {loadingPage ? (
                    // Full page skeleton loader
                    <div style={{ padding: 40 }}>
                      <Skeleton height={40} width={300} style={{ marginBottom: 20 }} />
                      <Skeleton height={200} style={{ marginBottom: 20 }} />
                      <Skeleton count={5} height={30} style={{ marginBottom: 10 }} />
                    </div>
                  ) : (
      <div className="row">
        <div className="col-lg-12 col-md-12">
                  <div className="pl-20" style={{float: "right"}}>
                      <Link onClick={registerCard}>
                      <button
                          type="button"
                          className="btn-fill-lmd radius-30 mb-3 text-light shadow-dodger-blue bg-dodger-blue">
                          <i className="fa-solid fa-plus" /> Register New Card / Wristband
                      </button>
                      </Link>
                     
                  </div>
        </div>
        
        <div className="col-lg-8">
          <div className="row">
          <div class="col-lg-12">
							<div class="card custom-card " style={{paddingBottom:"10px"}}>
                <div className="card-body map-card gradient-my-blue">
                <div class="item-title mb-2" style={{color:"white"}}><b>SUMMARY</b></div>
								<div class="row" >
									<div class="col-xl-4 col-lg-12 col-sm-6 pr-0 pl-0 border-right" >
										<div class="text-center" >
											<h2 class="mb-1 number-font" style={{color:"white"}}><span class="counter">{allCardsCount ? allCardsCount.total_p : "..."}</span></h2>
											<p class="mb-0 text-light"> Total</p>
										</div>
									</div>

                  <div class="col-xl-4 col-lg-12 col-sm-6 pr-0 pl-0 border-right" >
										<div class="text-center" >
											<h2 class="mb-1 number-font" style={{color:"white"}}><span class="counter">{cardsCount ? cardsCount.total_p : "..."}</span></h2>
											<p class="mb-0 text-light"> Cards</p>
										</div>
									</div>

                  <div class="col-xl-4 col-lg-12 col-sm-6 pr-0 pl-0">
										<div class="text-center">
											<h2 class="mb-1 number-font" style={{color:"white"}}><span class="counter">{wristbandsCount ? wristbandsCount.total_p : "..."}</span></h2>
											<p class="mb-0 text-light"> Wristbands</p>
										</div>
									</div>

                  
								</div>
              </div>
							</div>
            </div>

            <div class="col-lg-12">
              <div className="card custom-card">
              
                <div className="card-body map-card">
                <div className="heading-layout1 mg-b-5">
        <TableHeader
          title="Buzz Cards / Wristbands List"
         subtitle="List of all the buzz cards and wristbands in their different categories" />
        <div className="dropdown">
          <Link className="dropdown-toggle" role="button" data-toggle="dropdown">...</Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item">
              <i className="fas fa-file-export"></i>Export
            </Link>
          </div>
        </div>
      </div>
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row>
                  <Col sm={12}>
                    <Nav variant="pills" className="flex-row mb-1">
                      <Nav.Item>
                        <Nav.Link size="sm" eventKey="first">
                          All{" "}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link size="sm" eventKey="second">
                          Assigned{" "}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link size="sm" eventKey="third">
                          Unassigned{" "}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link size="sm" eventKey="fourth">
                          Inactive{" "}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link size="sm" eventKey="fifth">
                          Lost{" "}
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>

                  <Col sm={12}>
                    <Tab.Content>
                      <Tab.Pane eventKey="first">
                        <AllCards/>
                      </Tab.Pane>

                      <Tab.Pane eventKey="second">
                        <AssignedCards/>

                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <UnassignedCards/>
                    
                      </Tab.Pane>
                      <Tab.Pane eventKey="fourth">
                        <InactiveCards/>
                    
                      </Tab.Pane>

                      <Tab.Pane eventKey="fifth">
                        <LostCards/>
                    
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
                </Tab.Container> 
              
            </div>
          </div>
        </div></div>
        </div>
        <div className="col-lg-4 col-md-12 col-12 col-sm-12">
          <div className="row">
              <div class="col-lg-12 col-md-12 col-12 col-sm-12">
                <div class="card custom-card">
                  
                  <div class="card-body">
                  <h6 style={{ marginBottom: 10 }}>Assigned Cards / Wristbands</h6>
                    <div class="mb-4">
                      <div class="text-small float-right font-weight-bold text-muted">{assignedCardsCount? assignedCardsCount.total_p:"..."}</div>
                      <div class="">Cards</div>
                      <div class="progress" data-height="5">
                        <div class="progress-bar bg-light-blue" role="progressbar" style={{width:"70%"}}></div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="text-small float-right font-weight-bold text-muted">{assignedWristbandsCount? assignedWristbandsCount.total_p:"..."}</div>
                      <div class="">Wristbands</div>
                      <div class="progress" data-height="5">
                        <div class="progress-bar l-bg-pink" role="progressbar" style={{width:"30%"}}></div>
                      </div>
                    </div>
                   
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                      <div className="card custom-card" style={{paddingBottom:"10px"}}>
                        <div className="card-body map-card">
                        <TableHeader
                            title="Assigned Cards / Wristbands Per School"
                            subtitle="Total number of assigned cards and wristbands for each registered school"
                            viewButton={
                              <Link onClick={handleReset} className="" style={{float:"right"}}><i class="fas fa-redo-alt ml-3"></i></Link>
                                 
                          } 
                        />
                        
    
  <table className="table mb-0 mw-100 color-span">
    <thead>
                <tr>
                <th className="w-50">School</th>
                <th></th>

                <th className="py-2 px-0" scope="col">Cards</th>
                <th className="py-2 px-0"scope="col"> Wristbands</th>
                </tr>
                </thead>
    <tbody>
      {Object.keys(assignedPerSchool).length > 0 ? (
        Object.keys(assignedPerSchool).map((schoolId, index) => {
          const school = assignedPerSchool[schoolId];
          return (
            <tr key={index}>
              <td className="py-2 px-0">
                <span className="w-50">{school.school_name}</span>
              </td>
              <td>:</td>
              <td className="py-2 px-0">
                <span className="">
                  {school.assigned["CARD"] !== undefined ? school.assigned["CARD"] : 0}
                </span>
              </td>
              <td className="py-2 px-0">
                <span className="">
                  {school.assigned["WRISTBAND"] !== undefined ? school.assigned["WRISTBAND"] : 0}
                </span>
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan="4" style={{ textAlign: "center" }}>
            No cards or wristbands assigned to any student.
          </td>
        </tr>
      )}
    </tbody>
  </table>


                        </div>
                      </div>
                    </div>
        </div></div>
      </div>)}
    </AppContainer>
  );
}

export default CardsPage;